<template>
    <el-config-provider :locale="locale">
      <keep-alive>
      <router-view />
      </keep-alive>
      <!-- 这里是内容 -->
    </el-config-provider>
</template>

<script>
import $ from 'jquery'
import "@/assets/main.css";
import { ElConfigProvider } from 'element-plus'

// 引入中文包
import zhCn from 'element-plus/lib/locale/lang/zh-cn'
export default {
  components: {
    [ElConfigProvider.name]: ElConfigProvider
  },
  created(){
   
  },
  setup() {
    const lang = () => {// eslint-disable-line no-unused-vars(如果运行时报错，就加上前面这行注释)
      location.reload()
    }
    let locale = zhCn
    return {
      locale
    }
  }
}
</script>

<style>
#app {
  margin: 0;
  padding: 0;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
/**禁止选中文本 */
* {
    -webkit-touch-callout:none;
    -webkit-user-select:none;
    -moz-user-select:none;
    -ms-user-select:none;
    user-select:none;
}
input, textarea {
    -webkit-user-select:text;
}
</style>
